const USPasswordRenewal = () => {
    return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              US Passport Renewal
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS provides a secure and convenient way to renew US passport. The US citizens can either visit a 
              TCS Express Centre to hand over their passports or arrange for a pickup of their documents to be 
              submitted to the nearest US embassy on their behalf. Selected TCS Express Centres are open 
              twenty-four hours, which makes it a more flexible and time-saving option.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/InternationalExpress/uspassport.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
        </div>
      
      </div>

    </div>

  )
};
export default USPasswordRenewal;